import { render, staticRenderFns } from "./wine-can-pack.vue?vue&type=template&id=7ddef195"
import script from "./wine-can-pack.vue?vue&type=script&lang=js"
export * from "./wine-can-pack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports